import React from "react";
import { Alert, Snackbar } from "@mui/material";

export enum SnackbarType {
  ERROR = "error",
  SUCCESS = "success",
  INFO = "info",
  WARNING = "warning",
}

interface Props {
  type: SnackbarType;
  message: string | null;
  open: boolean;
  onClose: () => unknown;
}
export const SnackbarComponent = ({ type, message, open, onClose }: Props) => {
  return (
    <Snackbar
      open={open}
      onClose={onClose}
      autoHideDuration={5000}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
    >
      <Alert severity={type} elevation={3} variant="filled">
        {message}
      </Alert>
    </Snackbar>
  );
};
